import { makeAutoObservable } from 'mobx';
import { StepperStore } from '../../shared/util-stores';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { InbodyDataField } from '../../shared/constants/inbody-info/inbodyData';
import { CombinedCustomerInfo } from '../interfaces/Customer';
import { customerService } from '../services/customerService';

type CustomerBodyMetrics = Record<
  Extract<InbodyDataField, 'weight' | 'percentBodyFat'>,
  number
>;
class CustomerSetupStore {
  stepperMethods: StepperStore;
  customerInfo: CombinedCustomerInfo | null = null;
  customerBodyMetrics: CustomerBodyMetrics | null = null;
  mealsPerDay: number | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.stepperMethods = new StepperStore();
  }

  setDefaultValues() {
    this.stepperMethods.setDefaultValues();
    this.customerInfo = null;
    this.customerBodyMetrics = null;
    this.mealsPerDay = null;
  }

  async getCustomerInfo(customerId: number) {
    const info = await customerService.getCustomerInfo(customerId);

    this.setCustomerInfo(info);
  }

  setCustomerInfo(info: CombinedCustomerInfo) {
    this.customerInfo = info;
  }

  setCustomerBodyMetrics(metrics: CustomerBodyMetrics) {
    this.customerBodyMetrics = metrics;
  }

  setMealsPerDay(mealsPerDay: number | string) {
    this.mealsPerDay = +mealsPerDay;
  }

  getEntityId(): number {
    if (!this.customerInfo) {
      throw new Error('Customer info is not loaded');
    }

    return this.customerInfo.user.entityId;
  }
}

const customerSetupStore = new CustomerSetupStore();
resetAllStore.addResetMethod(customerSetupStore.setDefaultValues);

export { customerSetupStore, CustomerSetupStore };
